import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	filterByCommittee, setDocumentFilter, setMeetingFilter
} from '../actions';

class FilterByCommittee extends Component {

	constructor( props ) {
		super( props );
		this.myCommittees = this.props.committees.filter( committee => this.props.myCommittees.includes( committee.code ) );
	}

	handleChange( event ) {
		this.props.filterByCommittee( event.target.value );
		switch ( this.props.mainTab ) {
			case 'meetings':
				this.props.setMeetingFilter( 'committee', event.target.value );
				break;
			case 'documents':
				this.props.setDocumentFilter( 'committee', event.target.value );
				break;
		}

	}

	setClassName( committee ) {
		let classes = 'btn btn-lg btn-filter';
		if ( this.props.committeeFilter === committee ) {
			classes += ' active';
		}
		return classes;
	}

	renderOptions() {

		return this.myCommittees.map( committee => (
			<option key={ committee.title.toLowerCase() } value={ committee.code.toLowerCase() } data-ccode={ committee.title.toLowerCase() }>{ committee.title }</option>
		) );

	}

	getDocumentsTabFilterValue() {
		return (typeof this.props.documentFilter.committee !== 'undefined'
		       ) ? this.props.documentFilter.committee : '';
	}

	render() {
		let value = (this.props.mainTab === 'documents'
		            )
			? this.getDocumentsTabFilterValue()
			: this.props.committeeFilter;
		return (
			<section className={ 'meeting-committee-options col-xs-12 col-md-3' }>
				<div className="btn-group policyGroup" role="group" aria-label="Policy Group Filter">
					<select className={ 'form-control' } onChange={ this.handleChange.bind( this ) } value={ value }>
						<option value={ '' } data-policyGroup='all'>All Committees</option>
						{ this.renderOptions() }
					</select>
				</div>
			</section>
		);
	}
}

function mapStateToProps( { committees, myCommittees, committeeFilter, mainTab, documentFilter } ) {
	return {
		committees, myCommittees, committeeFilter, mainTab, documentFilter
	};
}

export default connect( mapStateToProps, {
	filterByCommittee, setDocumentFilter, setMeetingFilter
} )( FilterByCommittee );